import Spacing from "@/components/common/Spacing";
import "./exclusives.scss";
import { Container } from "react-bootstrap";
import decor from "@/assets/line-group-2.png";

interface Data {
  exclusiveTitle: string;
  exclusives: string[];
}

interface Props {
  data: Data;
  hideDecor?: boolean;
}

const Exclusives = ({ data, hideDecor }: Props) => {
  return (
    <div className="exclusives-container">
      {!hideDecor && (
        <img src={decor} alt="pixado" className="exclusives-decor" />
      )}
      <Container>
        <Spacing size={3} />
        <div className="exclusives">
          <div className="title-2 exclusiveTitle">{data.exclusiveTitle}</div>
          <div className="bubble exclusives-bubble">
            <div className="body">
              {data.exclusives.map((item, index) => (
                <div key={index}>
                  {item}
                  {index < data.exclusives.length - 1 && <br />}
                </div>
              ))}
            </div>
          </div>
        </div>
        <Spacing size={3} />
      </Container>
    </div>
  );
};

export default Exclusives;